import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import esLocale from 'element-ui/lib/locale/lang/es'

Vue.use(VueI18n)

const messages = {
  en: {
    ...require('@/locales/en.json'),
    ...enLocale
  },
  es: {
    ...require('@/locales/es.json'),
    ...esLocale
  },
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'es',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es',
  messages,
})
